export default "__VITE_ASSET__BfbtJmjL__"